import script from "./ONas.vue?vue&type=script&setup=true&lang=ts"
export * from "./ONas.vue?vue&type=script&setup=true&lang=ts"

import "./ONas.vue?vue&type=style&index=0&id=272dd4c5&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-272dd4c5"]])

export default __exports__